export const getOnboardingQuery = `
  query allOnboardings($obj: JSON){
    allOnboardings(where: $obj){
      Onboardings{
        averagefastball
        battingprefencevalue
        currentlevelofbaseball
        currentlevelofschool
        dateofbirth
        doyouusetwitterforsports
        exitvelocity
        fastball
        fastballvelocity
        gpascale
        gradvalue
        gpascalevalue
        heightincentimeter
        heightinfeet
        heightininches
        highschoolname
        highscoolstatus
        id
        infieldvelocity
        instagramaccountname
        needhelpforcollegerecruitingprocess
        recruitingcollagename
        primaryposition
        primarypositioncolumnvalue
        profileimages
        recruitingprocess
        schoolzipcode
        secondaryposition
        secondarypositioncolumnvalue
        spinratefastball
        throwingprefencevalue
        twitteraccountname
        userid
        usetwitterforschool
        wanttolearnsocialmediaforsportgoal
        weight
        weightinkilogram
        weightgpa
        unweightedgpa
        yardsprint
        yearvarsity
        gpaScaleValue
        primaryPosition
        currentLevelOfBaseball
        currentLevelOfSchool
        secondaryPosition
        heightInfeet
        heightInInches
      }
    }
  } 
  `;

export const saveOnboardingQuery = `
  mutation saveOnboarding($obj: OnboardingInput!){
    saveOnboarding(obj: $obj){
        averagefastball
        battingprefencevalue
        currentlevelofbaseball
        currentlevelofschool
        dateofbirth
        doyouusetwitterforsports
        exitvelocity
        fastball
        fastballvelocity
        gpascale
        gradvalue
        gpascalevalue
        heightincentimeter
        heightinfeet
        heightininches
        highschoolname
        highscoolstatus
        id
        infieldvelocity
        needhelpforcollegerecruitingprocess
        primaryposition
        primarypositioncolumnvalue
        profileimages
        recruitingprocess
        schoolzipcode
        secondaryposition
        secondarypositioncolumnvalue
        spinratefastball
        throwingprefencevalue
        twitteraccountname
        userid
        usetwitterforschool
        wanttolearnsocialmediaforsportgoal
        recruitingcollagename
        weight
        weightinkilogram
        weightgpa
        yardsprint
        gpaScaleValue
        primaryPosition
        currentLevelOfBaseball
        currentLevelOfSchool
        secondaryPosition
        heightInfeet
        heightInInches
        yearvarsity
    }
  } 
  `;

export const getAthleteHeightWeight = `
  query allAthleteheightandweights($obj: JSON){
    allAthleteheightandweights(where: $obj){
      Athleteheightandweights{
        id
      }
    }
    }
  `;

export const saveAthleteHeightWeight = `
  mutation saveAthleteheightandweight($obj: AthleteheightandweightInput!){
    saveAthleteheightandweight(obj: $obj){
id
    }
  }
  `;

  export const getAllVarsityQuery = `
  {
    allVarsities{
      Varsities{
        id
        varsityname
      }
      totalCount
    }
  }
  `;

  export const saveUserDataQuery = `
mutation saveUserdata($obj: UserdataInput!){
  saveUserdata(obj:$obj){
    id
  }
}
`;